import { render, staticRenderFns } from "./TableTransactions.vue?vue&type=template&id=4428eb98&scoped=true&"
import script from "./TableTransactions.vue?vue&type=script&lang=js&"
export * from "./TableTransactions.vue?vue&type=script&lang=js&"
import style0 from "./TableTransactions.vue?vue&type=style&index=0&id=4428eb98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4428eb98",
  null
  
)

export default component.exports